module.exports = __webpack_public_path__ + "static/media/Subtract-3.466a8182.svg";